import React from "react";
import ReactMde, { ReactMdeProps } from "react-mde";
import * as Showdown from "showdown";
import "react-mde/lib/styles/css/react-mde-all.css";
import { $, merge } from "glamor";
import theme from "styles/theme";

export enum Tabs {
    Write = "write",
    Preview = "preview",
}

const converter = new Showdown.Converter({
    tables: true,
    simplifiedAutoLink: true,
    strikethrough: true,
    tasklists: true,
});

export const TermsAndConditionsEditor: React.FunctionComponent<Partial<ReactMdeProps & { preview: boolean }>> = ({
    toolbarCommands,
    value,
    onChange,
    selectedTab,
    onTabChange,
    commands,
    preview,
    refs,
}) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                fontSize: "14px",
            },
            $(" strong", {
                fontWeight: "bold",
            }),
            $(" em", {
                fontStyle: "italic",
            }),
            $(" ul", {
                listStyleType: "disc",
            }),
            ...(preview
                ? [
                      $(" .mde-header", {
                          display: "none !important",
                      }),
                      $(" .mde-preview-content", {
                          height: "300px !important",
                          overflowY: "auto",
                          color: theme.palette.darkGrey,
                      }),
                  ]
                : [])
        );
    }, [preview]);

    const handleGenerateMarkdownPreview = React.useCallback((markdown) => {
        return Promise.resolve(converter.makeHtml(markdown));
    }, []);

    return (
        <div {...styles}>
            <ReactMde
                value={value}
                onChange={onChange}
                selectedTab={selectedTab}
                onTabChange={onTabChange}
                generateMarkdownPreview={handleGenerateMarkdownPreview}
                childProps={{
                    writeButton: {
                        tabIndex: -1,
                    },
                }}
                refs={refs}
                commands={commands}
                toolbarCommands={toolbarCommands}
            />
        </div>
    );
};
